import React from "react";
import styles from "./MainApp.organisms.Dashboard.PercentageBar.module.scss";

const PercentageBar = ({ percentage = 1, color = "#62d862", }) => {
  return (
      <div className={styles["percentage-bar-container"]}
      >
        <div
          className={styles["percentage-bar-inner"]}
          style={{ width: `${percentage}%`, backgroundColor: `${color}` }}
        >
          <div className={styles["percentage-bar-circle"]} style={{ backgroundColor: `${color}` }}></div>
        </div>
      </div>
  );
};

export default PercentageBar;
